
import React from 'react';
import _ from 'lodash'
import { StripeCardElementOptions } from '@stripe/stripe-js';
import {
    CardElement,
    Elements,
    useElements,
    useStripe,
    CardElementComponent
} from "@stripe/react-stripe-js";
import { LoadElementsStripe } from './LoadElementsStripe';
import { createStyles, makeStyles } from '@mui/styles';
import { Alert, Collapse, IconButton, Theme, Box, TextField, Grid, Button, CardContent, Card, OutlinedInput, FormHelperText, useFormControl, FormControl, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Spinner } from 'react-bootstrap';
import styleRules from '../../utils/styleRules'

import ButtonLoading from '../ButtonLoading';

const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
        base: {
            iconColor: "#515e80",
            color: "#444",
            fontWeight: 500,
            lineHeight: `50px`,
            fontFamily: `"proxima-nova", "proxima nova", "helvetica neue", "helvetica", "arial", sans-serif`,
            fontSize: "16px",
            fontSmoothing: "antialiased",
            ":-webkit-autofill": {
                color: "#444"
            },
            "::placeholder": {
                color: "#444"
            }
        },
        invalid: {
            iconColor: "#515e80",
            color: "#ffc7ee"
        }
    }
};


const useStyles = makeStyles((theme: Theme) => createStyles({
    wrapperTextField: {
        // display: "flex",
        // alignItems: "center",
        // border: "1px solid #dfdfdf",
        // borderRadius: 10,
        border: "1px solid #dfdfdf",
        borderRadius: "3px",
        paddingLeft: "10px",
        // backgroundColor: "#f0f1f2",
        "& .CardField-input-wrapper": {
            // backgroundColor: "#f0f1f2",
            // borderRadius: 10,
        }
    },
    containerTextInputStripe: {
        display: "flex",
        MsFlexAlign: "center",
        alignItems: "center",
        border: "1px solid #dfdfdf",
        borderRadius: "3px",
        paddingLeft: "10px"
    },
    textFieldCreditCard: {
        // fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        // backgroundColor: "#f0f1f2",
        // borderRadius: 10,
    },


}))
export interface BillingDetailsAddressT {

    city?: string;
    country?: string;
    line1?: string;
    line2?: string;
    postal_code?: string;
    state?: string;
}

export interface BillingDetailsT {

    address?: BillingDetailsAddressT;
    email?: string;
    name?: string;
    phone?: string;
}

interface IFormSaveCardProps {
    publishableKey: string
    completeSaveCard(paymentMethodId: string): Promise<string>
    optionsCardField?: StripeCardElementOptions
    back(): void
}


interface IFormCardFieldProps extends IFormSaveCardProps {
}



const FormCardField: React.FC<IFormCardFieldProps> = (props) => {
    const stripe = useStripe();
    const classes = useStyles()
    const [validated, setValidated] = React.useState(false);
    const elements = useElements();
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [processing, setProcessing] = React.useState(false);
    const [errorCard, setErrorCard] = React.useState(null);
    const [cardComplete, setCardComplete] = React.useState(false);
    const [paymentMethod, setPaymentMethod] = React.useState(null);
    const [billingDetails, setBillingDetails] = React.useState<BillingDetailsT>({
        email: null,
        phone: null,
        name: "",
        address: null
    });

    const [openAlert, setOpenAlert] = React.useState(false);


    const handleSubmit = async (event) => {
        event.preventDefault();
        return await saveCard()
    };


    const saveCard = async (): Promise<string> => {

        setValidated(true)
        if (!stripe || !elements || !billingDetails.name || billingDetails.name == "") {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.

            throw new Error("Please check and input correct fields!")
        }

        if (errorCard) {
            elements.getElement("card").focus();
            if (errorMessage && _.has(errorMessage, "message")) {
                throw new Error(errorMessage.message)
            }
            throw new Error("Please check and input correct fields!")
        }

        if (cardComplete) {
            setProcessing(true);
        }

        try {
            let paymentMethodId = null
            if (!paymentMethod) {
                /**
                 * step 1
                 */
                const payload = await stripe.createPaymentMethod({
                    type: "card",
                    card: elements.getElement(CardElement),
                    billing_details: billingDetails
                });

                if (payload.error) {
                    setErrorMessage(payload.error);
                    setProcessing(false);
                    throw new Error(`${payload.error.message}`);

                } else {
                    paymentMethodId = payload.paymentMethod.id
                    setPaymentMethod(payload.paymentMethod);
                }
            } else {
                paymentMethodId = paymentMethod.id
            }

            let completeSaveCard = await props.completeSaveCard(paymentMethodId)
            setProcessing(false)
            if (completeSaveCard) {
                setOpenAlert(true)
            }
            return "Card saved."
        } catch (error) {
            setProcessing(false);
            setErrorMessage(error);
            throw error
        }
    };



    return (
        <Box >
            <Card>
                <CardContent>
                    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
                        <Grid container spacing={3} >
                            <Grid item xs={12}>
                                <FormControl fullWidth required>
                                    <OutlinedInput required error={validated && billingDetails.name == ""} placeholder="Cardholder name *"
                                        onChange={(e) => {
                                            setBillingDetails({ ...billingDetails, name: e.target.value });
                                        }}

                                    />
                                    {validated && billingDetails.name == "" && <FormHelperText error={true}>Required</FormHelperText>}
                                </FormControl>

                            </Grid>
                          
                            <Grid item xs={12} >
                                <Box className={`${classes.wrapperTextField} ${classes.containerTextInputStripe}`} >

                                    <CardElement
                                        className={`${classes.textFieldCreditCard}`}
                                        options={styleRules(CARD_OPTIONS, props.optionsCardField)}
                                        onChange={(e) => {

                                            if (e.error != null) {
                                                setOpenAlert(true)
                                            } else {
                                                setOpenAlert(false)
                                            }

                                            setErrorMessage(e.error);
                                            setErrorCard(e.error)
                                            setCardComplete(e.complete)

                                        }} />
                                </Box>
                                <Collapse in={openAlert} className="mt-2">
                                    <Alert
                                        severity={errorCard ? "error" : "success"}
                                        action={
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="small"
                                                onClick={() => {
                                                    setOpenAlert(false);
                                                    setTimeout(() => {
                                                        setErrorCard(null)
                                                        setErrorMessage(null)
                                                    }, 500);
                                                }}
                                            >
                                                <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                        }
                                        sx={{ mb: 2 }}
                                    >
                                        {errorCard && openAlert && errorMessage && errorMessage.message && errorMessage.message}
                                        {cardComplete && openAlert && "Card saved."}
                                    </Alert>
                                </Collapse>
                            </Grid>
                            <Grid item xs={12} >
                                <ButtonLoading
                                    customButton={Button}
                                    customButtonProps={{
                                        type: "submit",
                                        variant: "contained",
                                        color: "success",
                                        fullWidth: true,
                                    }}

                                    onClickFetching={async (e): Promise<string> => {
                                        e.preventDefault()
                                        try {
                                            const res = await saveCard()
                                            return res
                                        } catch (error) {
                                            throw error
                                        }
                                    }}
                                    processingComponent={(<div style={{}}>
                                        <Typography><Spinner animation="border" size="sm" /> Processing...</Typography>
                                    </div>
                                    )}>
                                    <Typography variant="button">Save Card</Typography>
                                </ButtonLoading>
                            </Grid>
                           
                        </Grid>
                    </Box>
                </CardContent>
            </Card>

        </Box>
    );
}




const FormSaveCard: React.FC<IFormSaveCardProps> = (props) => {
    const [stripe, setStripe] = React.useState(null)

    return (
        <LoadElementsStripe
            publishableKey={props.publishableKey}
            onFinishedLoad={(stripe) => {
                setStripe(stripe)
            }}>

            {stripe && <FormCardField {...props} />}
        </LoadElementsStripe>
    );
}
export default FormSaveCard
export { FormSaveCard }